import React, { Fragment } from 'react'
import { Button, Icon, InputNumber, Popconfirm } from 'antd'
import { MarginBottonContainer } from 'Common/styled'

const DiscountButton = props => (
  <Popconfirm
    placement="topRight"
    icon={<Icon type="euro" />}
    title={
      <Fragment>
        <p>
          <small>Applica una % di sconto a tutte le referenze</small>
        </p>
        <InputNumber
          style={{ width: '100%' }}
          placeholder="Inserisci % di sconto"
          id="discount-input"
        />
      </Fragment>
    }
    onConfirm={() => {
      // Take value from input
      let discount = Number(Number(document.getElementById('discount-input').value).toFixed(2));
      discount = isNaN(discount) ? 0 : discount > 100 ? 100 : discount < 0 ? 0 : discount;
      // Apply discount (in parent component)
      props.applyDiscountCallback(discount)
      // Clear input value
      document.getElementById('discount-input').value = ''
    }}
    okText="Applica"
    cancelText="Annulla">
    <MarginBottonContainer>
      <Button type="primary" disabled={props.disabled}>
        Sconto cumulativo
      </Button>
    </MarginBottonContainer>
  </Popconfirm>
)
export default DiscountButton



// WEBPACK FOOTER //
// ./src/components/DiscountButton/index.js